"use client";

import {useEffect, useState} from "react";

interface MonthlyTimerProps {
    minimal?: boolean;
    className?: string;
}

export default function MonthlyTimer({minimal = false, className = ""}: MonthlyTimerProps) {
    const [timeRemaining, setTimeRemaining] = useState<string>("");

    useEffect(() => {
        const calculateTimeRemaining = () => {
            const now = new Date();

            // Calcola la fine del mese corrente
            const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59, 999);

            // Calcola la differenza in millisecondi
            const diff = endOfMonth.getTime() - now.getTime();

            if (diff <= 0) {
                return "Offerta scaduta";
            }

            // Converti in giorni, ore, minuti
            const days = Math.floor(diff / (1000 * 60 * 60 * 24));
            const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

            return `${days}g ${hours}h ${minutes}m`;
        };

        // Calcola immediatamente
        setTimeRemaining(calculateTimeRemaining());

        // Aggiorna ogni minuto
        const interval = setInterval(() => {
            setTimeRemaining(calculateTimeRemaining());
        }, 60000); // Aggiorna ogni 60 secondi

        return () => clearInterval(interval);
    }, []);

    if (minimal) {
        return (
            <span className={className || "text-primary text-lg font-medium leading-tight"}>
                {timeRemaining || "Caricamento..."}
            </span>
        );
    }

    return (
        <div
            className={`fixed right-0 top-1/4 -translate-y-1/2 flex items-center gap-2 bg-white/90 backdrop-blur-sm px-3 py-2 rounded-l-lg shadow-lg border border-gray-200 z-50 transition-all hover:shadow-xl ${className}`}>
            <div className="flex flex-col">
                <span className="text-[#D20000] text-lg font-semibold leading-tight">Offerte a tempo</span>
                <span className="text-primary text-lg font-medium leading-tight">
                    {timeRemaining || "Caricamento..."}
                </span>
            </div>
        </div>
    );
}
